import type { LovOutilFpeDTO } from '@/features/api/extranet/dto/Demande/OUTILFPE'
import {
  getNaturesFichiersOutilFpe as getNaturesFichiers,
  propertyStatusConfiguration,
  reglesConfiguration,
} from '@/features/domaine/regles-akto/OUTILFPE'
import { outilfpeService } from '@/features/services/demande'
import { buildDemandeStore } from '../shared'

export const useDemandeOutilFPEStore = buildDemandeStore<'MODEL_OUTIL_FPE', LovOutilFpeDTO>({
  model: 'MODEL_OUTIL_FPE',
  typeDemande: 'SpecifiqueTT',
  module: 'demande',
  demandeService: outilfpeService,
  propertyStatusConfiguration,
  reglesConfiguration,
  getNaturesFichiers,
})
